import { Button } from '@/isomorphic/components/typography/button/button';
import { StepCommonProps } from '../types';
import { useLogout } from '@/hooks/use-logout';
import { useEffect } from 'react';

export const SubmittedApplication = ({ getLabel }: StepCommonProps) => {
    const { logout } = useLogout();

    useEffect(() => {
        return () => {
            logout();
        };
    }, []);

    return (
        <div className="r-relative r-mx-auto r-mb-8 r-max-w-2xl r-space-y-4">
            <div className="r-space-y-8 r-rounded-xl r-border-2 r-border-primary-200 r-bg-white r-p-6">
                <div className="r-flex r-flex-col r-items-center r-space-y-6 r-text-center">
                    <h2 className="r-text-2xl r-font-semibold r-text-primary-500">{getLabel('submittedTitle')}</h2>
                    <p className="r-text-lg">{getLabel('submittedDescription')}</p>
                    <div className="r-mx-auto r-flex r-max-w-xs r-flex-col r-gap-4">
                        <Button fullWidth to={'/'}>
                            {getLabel('landingPageButton')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
